import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Slide,
  IconButton,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  fetchEmpresas,
  fetchPuestos,
  fetchConvenios,
} from "../../services/empleados.api";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DIALOG_PAPER_PROPS = {
  style: { borderRadius: 15, padding: "10px" },
};

const CLOSE_BTN_SX = { color: "grey.500" };

const CategoriasForm = ({ open, handleClose, handleSubmit, initialData }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    empresa_id: "",
    sueldo_basico: "",
    puesto_id: "",
    convenio_id: "",
    sisven_id: "",
  });
  const [empresas, setEmpresas] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [convenios, setConvenios] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const loadSelects = async () => {
      try {
        const [empRes, pRes, convRes] = await Promise.all([
          fetchEmpresas(),
          fetchPuestos(),
          fetchConvenios(),
        ]);

        // const getArrayData = (res) => {
        //   if (!res) return [];
        //   if (Array.isArray(res)) return res;
        //   if (res.data && Array.isArray(res.data)) return res.data;
        //   return [];
        // };

        setEmpresas(empRes);
        setPuestos(pRes);
        setConvenios(convRes.data);
      } catch (error) {
        console.error("Error loading selects for CategoriasForm:", error);
      }
    };
    loadSelects();
  }, []);

  useEffect(() => {
    if (initialData) {
      setFormData({
        nombre: initialData.nombre || "",
        empresa_id: initialData.empresa_id || "",
        sueldo_basico: initialData.sueldo_basico || "",
        puesto_id: initialData.puesto_id || "",
        convenio_id: initialData.convenio_id || "",
        sisven_id: initialData.sisven_id || initialData.id_sisven || "",
      });
    } else {
      setFormData({
        nombre: "",
        empresa_id: "",
        sueldo_basico: "",
        puesto_id: "",
        convenio_id: "",
        sisven_id: "",
      });
    }
    setErrors({});
  }, [initialData, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const validate = () => {
    const newErrors = {};

    // Nombre
    if (!formData.nombre.trim()) {
      newErrors.nombre = "El nombre es obligatorio";
    } else if (formData.nombre.trim().length > 100) {
      newErrors.nombre = "El nombre no puede exceder los 100 caracteres";
    }

    // Empresa
    if (!formData.empresa_id) {
      newErrors.empresa_id = "La empresa es obligatoria";
    }

    // Puesto
    if (!formData.puesto_id) {
      newErrors.puesto_id = "El puesto es obligatorio";
    }

    // Convenio
    if (!formData.convenio_id) {
      newErrors.convenio_id = "El convenio es obligatorio";
    }

    // Sueldo Basico
    if (!formData.sueldo_basico) {
      newErrors.sueldo_basico = "El sueldo es obligatorio";
    } else if (isNaN(formData.sueldo_basico)) {
      newErrors.sueldo_basico = "Debe ser un valor numérico";
    } else if (parseFloat(formData.sueldo_basico) < 0) {
      newErrors.sueldo_basico = "Debe ser un número positivo";
    }

    // Sisven ID
    if (!formData.sisven_id) {
      newErrors.sisven_id = "El ID Sisven es obligatorio";
    } else if (isNaN(formData.sisven_id)) {
      newErrors.sisven_id = "Debe ser un valor numérico";
    } else if (formData.sisven_id.toString().length > 20) {
      newErrors.sisven_id = "No puede exceder los 20 dígitos";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      handleSubmit(formData);
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={DIALOG_PAPER_PROPS}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{ fontWeight: "bold", color: "primary.main" }}
        >
          {initialData ? "Editar Categoría" : "Nueva Categoría"}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={CLOSE_BTN_SX}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={onSubmit}>
        <DialogContent dividers>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                name="nombre"
                label="Nombre de la Categoría"
                fullWidth
                variant="outlined"
                value={formData.nombre}
                onChange={handleChange}
                error={!!errors.nombre}
                helperText={errors.nombre}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.empresa_id}>
                <InputLabel>Empresa</InputLabel>
                <Select
                  name="empresa_id"
                  value={formData.empresa_id}
                  label="Empresa"
                  onChange={handleChange}
                >
                  {empresas.map((emp) => (
                    <MenuItem key={emp.idEmpresa} value={emp.idEmpresa}>
                      {emp.empresa}
                    </MenuItem>
                  ))}
                </Select>
                {errors.empresa_id && (
                  <Box
                    sx={{
                      color: "error.main",
                      fontSize: "0.75rem",
                      px: 2,
                      mt: 0.5,
                    }}
                  >
                    {errors.empresa_id}
                  </Box>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="sueldo_basico"
                label="Sueldo Básico"
                type="number"
                fullWidth
                variant="outlined"
                value={formData.sueldo_basico}
                onChange={handleChange}
                error={!!errors.sueldo_basico}
                helperText={errors.sueldo_basico}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.puesto_id}>
                <InputLabel>Puesto</InputLabel>
                <Select
                  name="puesto_id"
                  value={formData.puesto_id}
                  label="Puesto"
                  onChange={handleChange}
                >
                  {puestos.map((p) => (
                    <MenuItem key={p.id} value={p.id}>
                      {p.puesto}
                    </MenuItem>
                  ))}
                </Select>
                {errors.puesto_id && (
                  <Box
                    sx={{
                      color: "error.main",
                      fontSize: "0.75rem",
                      px: 2,
                      mt: 0.5,
                    }}
                  >
                    {errors.puesto_id}
                  </Box>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.convenio_id}>
                <InputLabel>Convenio</InputLabel>
                <Select
                  name="convenio_id"
                  value={formData.convenio_id}
                  label="Convenio"
                  onChange={handleChange}
                >
                  {convenios?.map((c) => (
                    <MenuItem key={c.id} value={c.id}>
                      {c.nombre}
                    </MenuItem>
                  ))}
                </Select>
                {errors.convenio_id && (
                  <Box
                    sx={{
                      color: "error.main",
                      fontSize: "0.75rem",
                      px: 2,
                      mt: 0.5,
                    }}
                  >
                    {errors.convenio_id}
                  </Box>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                name="sisven_id"
                label="ID Sisven"
                fullWidth
                variant="outlined"
                value={formData.sisven_id}
                onChange={handleChange}
                error={!!errors.sisven_id}
                helperText={errors.sisven_id}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleClose} color="inherit" variant="text">
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ boxShadow: 3 }}
          >
            {initialData ? "Actualizar" : "Guardar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CategoriasForm;
